/* =====================================================================
   CONFIGURATION — tout ce qui peut changer se modifie ici
   ===================================================================== */
const CONFIG = window.YAMOUNA_CONFIG || {};
/* Horaires : 0 = dimanche … 6 = samedi. [heure début, heure fin] */
const HOURS = {
  0: [[19,23]],
  1: [[19,23]],
  2: [[12,14],[19,23]],
  3: [[12,14],[19,23]],
  4: [[12,14],[19,23]],
  5: [[12,14],[19,23]],
  6: [[12,14],[19,23]]
};
/* La carte (prix, plats, descriptions) — générée depuis data/menu.json */
const MENU = window.YAMOUNA_MENU || [];

/* ===================== Textes FR / EN ===================== */
const T = {
  fr: {
    "nav.story":"Notre histoire","nav.menu":"La carte","nav.photos":"Photos","nav.reviews":"Avis","nav.order":"Commander","nav.contact":"Contact",
    "hero.eyebrow":"Cuisine indienne traditionnelle · Rennes",
    "hero.lede":"Une table familiale, de père en fils depuis 2008. Currys mijotés, grillades et nans cuits au four tandoor, à tout petits prix.",
    "hero.cta.menu":"Voir la carte","cta.call":"Appeler","cta.uber":"Livraison Uber Eats","hero.lunch":"Menu midi dès 10 €",
    "story.eyebrow":"Notre histoire","story.logo":"Notre nouvelle enseigne, rue de Robien","ph.sign":"Notre enseigne","ph.curry":"Nos currys","ph.nan":"Nans du tandoor","story.title":"Une maison de famille, transmise de père en fils.",
    "story.p1":"Depuis 2008, Le Yamouna accueille les Rennais en plein centre-ville, au 16 rue de Robien. Le restaurant se transmet de père en fils, et avec lui les recettes de la cuisine indienne traditionnelle.",
    "story.p2":"Nos habitués du centre-ville viennent pour retrouver leurs plats préférés. Tout le monde repart satisfait de l'assiette comme de l'accueil.",
    "pil.1.t":"Une affaire de famille","pil.1.d":"Même maison, même exigence et même savoir-faire depuis l'ouverture.",
    "pil.2.k":"Prix très doux","pil.2.t":"À partir de 10 €","pil.2.d":"Le menu midi complet : entrée, plat et dessert.",
    "pil.3.t":"La tradition au four","pil.3.d":"Le tandoor est un four en argile chauffé au charbon, où la chaleur dépasse 400 °C. Les nans y gonflent contre la paroi et les viandes marinées y sont saisies en quelques minutes : dorées dehors, moelleuses dedans.",
    "spec.eyebrow":"Les plus demandés","spec.title":"Nos trois incontournables","spec.lede":"Les plats que nos clients commandent encore et encore.",
    "spec.1.tag":"N° 47 · Poulet","spec.1.d":"Blanc de poulet grillé au tandoor, nappé d'une sauce onctueuse à la crème et aux noix de cajou.",
    "spec.2.tag":"N° 95 · Pain du tandoor","spec.2.n":"Nan fromage","spec.2.d":"La galette moelleuse cuite contre la paroi du four, fourrée au fromage fondant.",
    "spec.3.tag":"N° 49 · Poulet","spec.3.n":"Poulet tikka massala","spec.3.d":"Blanc de poulet mariné, grillé au tandoor puis mijoté dans une sauce aux légumes et aux épices.",
    "menu.eyebrow":"La carte","menu.title":"Toute la carte du Yamouna","menu.lede":"Les numéros vous aident à commander par téléphone. Prix en euros.",
    "menu.veg":"Végétarien uniquement","leg.veg":"Végétarien","leg.hot":"Relevé d'origine","leg.hot2":"Très relevé d'origine","best":"Best-seller",
    "menu.foot":"Nos plats sont préparés modérément épicés. Relevé ou très relevé sur simple demande. Carte des vins disponible au restaurant. Une allergie, une demande particulière ? Parlez-en à l'équipe.",
    "menu.pdf":"Télécharger la carte (PDF)","plats.open":"Voir nos plats en photo","plats.title":"Nos plats en photo","plats.all":"Tout télécharger","plats.one":"Télécharger","plats.close":"Fermer","plats.wait":"Préparation…","plats.count":"photos","menu.empty":"Pas de plat végétarien dans cette rubrique.",
    "ph.eyebrow":"En images","ph.title":"À la table du Yamouna","ph.insta":"Nos plats, la salle et les coulisses : toutes nos photos sont sur Instagram.","ph.follow":"Suivre sur Instagram",
    "rv.eyebrow":"Avis clients","rv.title":"Nos clients en parlent mieux que nous",
    "rv.lede":"Quelques avis laissés sur Google. Vous êtes venu nous voir ? Votre avis aide d'autres gourmands à nous découvrir.",
    "rv.read":"Lire tous les avis Google","rv.write":"Laisser un avis","rv.src":"Avis Google","ph.table":"La table du Yamouna",
    "or.eyebrow":"À emporter · livraison · groupes","or.title":"Le Yamouna, chez vous aussi",
    "or.take.t":"À emporter","or.take.d":"Appelez-nous pour passer commande, puis venez la récupérer au 16 rue de Robien. Donnez simplement les numéros des plats.",
    "or.del.t":"En livraison","or.del.d":"Commandez et payez en ligne sur Uber Eats, livré chez vous à Rennes.","or.del.b":"Commander sur Uber Eats",
    "gr.t":"Groupes & privatisation","gr.d":"Anniversaire, repas d'équipe, réunion de famille : dites-nous ce que vous préparez, nous revenons vers vous rapidement.",
    "gr.name":"Votre nom","gr.phone":"Téléphone","gr.date":"Date souhaitée","gr.count":"Nombre de personnes","gr.type":"Type de demande",
    "gr.type.group":"Table pour un groupe","gr.type.private":"Privatisation du restaurant","gr.msg":"Message (facultatif)",
    "gr.send":"Envoyer la demande par e-mail","gr.call":"Ou appeler","gr.hint":"Votre demande s'ouvre dans votre messagerie, prête à être envoyée.",
    "ct.eyebrow":"Infos pratiques","ct.title":"Venir au Yamouna","ct.area":"Quartier Saint-Hélier, à deux pas du centre-ville.","ct.route":"Itinéraire Google Maps",
    "ct.hours":"Horaires","ct.good":"Bon à savoir",
    "f.access":"Accessible aux personnes à mobilité réduite","f.park":"Stationnement facile à proximité","f.groups":"Groupes bienvenus",
    "f.kids":"Enfants bienvenus, menu enfant à 10 €","f.pets":"Animaux acceptés","f.diet":"Plats végétariens et demandes alimentaires sur simple demande","f.pay":"Tous moyens de paiement acceptés",
    "ft.tag":"Restaurant indien traditionnel · Rennes · depuis 2008","ft.legal":"Mentions légales","ft.credit":"Site imaginé et conçu par","mb.route":"Itinéraire","mb.order":"Commander",
    days:["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"],
    closedLunch:"midi fermé", openUntil:h=>`Ouvert · jusqu'à ${h}h`, opensToday:h=>`Fermé · ouvre à ${h}h`,
    opensTomorrow:h=>`Fermé · ouvre demain à ${h}h`, opensOn:(d,h)=>`Fermé · ouvre ${d.toLowerCase()} à ${h}h`,
    subj:f=>`Demande de ${f.type==="private"?"privatisation":"réservation de groupe"}${f.date?" – "+f.date:""}`,
    wa:(f)=>`Bonjour Le Yamouna, je souhaite faire une demande de ${f.type==="private"?"privatisation":"réservation de groupe"}.\nNom : ${f.name||"-"}\nTéléphone : ${f.phone||"-"}\nDate : ${f.date||"-"}\nNombre de personnes : ${f.count||"-"}\n${f.msg?"Message : "+f.msg:""}`,
    tabsLabel:"Rubriques de la carte"
  },
  en: {
    "nav.story":"Our story","nav.menu":"Menu","nav.photos":"Photos","nav.reviews":"Reviews","nav.order":"Order","nav.contact":"Contact",
    "hero.eyebrow":"Traditional Indian cuisine · Rennes",
    "hero.lede":"A family restaurant, handed down from father to son since 2008. Slow-cooked curries, grills and naans baked in the tandoor oven, at very gentle prices.",
    "hero.cta.menu":"See the menu","cta.call":"Call us","cta.uber":"Uber Eats delivery","hero.lunch":"Lunch menu from €10",
    "story.eyebrow":"Our story","story.logo":"Our new sign on rue de Robien","ph.sign":"Our sign","ph.curry":"Our curries","ph.nan":"Tandoor naans","story.title":"A family house, passed from father to son.",
    "story.p1":"Since 2008, Le Yamouna has welcomed guests in the heart of Rennes, at 16 rue de Robien. The restaurant has passed from father to son, and with it the recipes of traditional Indian cooking.",
    "story.p2":"Our city-centre regulars come back for their favourite dishes. Everyone leaves happy with the food and the welcome.",
    "pil.1.t":"A family business","pil.1.d":"Same house, same standards and same know-how since day one.",
    "pil.2.k":"Gentle prices","pil.2.t":"From €10","pil.2.d":"The full lunch menu: starter, main course and dessert.",
    "pil.3.t":"Tradition from the oven","pil.3.d":"The tandoor is a charcoal-fired clay oven running above 400 °C. Naans puff up against its wall and marinated meats sear in minutes: golden outside, tender inside.",
    "spec.eyebrow":"Most ordered","spec.title":"Our three must-tries","spec.lede":"The dishes our guests order again and again.",
    "spec.1.tag":"No. 47 · Chicken","spec.1.d":"Tandoor-grilled chicken breast in a silky cream and cashew sauce.",
    "spec.2.tag":"No. 95 · Tandoor bread","spec.2.n":"Cheese naan","spec.2.d":"Soft flatbread baked against the oven wall, filled with melting cheese.",
    "spec.3.tag":"No. 49 · Chicken","spec.3.n":"Chicken tikka masala","spec.3.d":"Marinated chicken breast, grilled in the tandoor then simmered in a spiced vegetable sauce.",
    "menu.eyebrow":"The menu","menu.title":"The full Yamouna menu","menu.lede":"Dish numbers make ordering by phone easy. Prices in euros.",
    "menu.veg":"Vegetarian only","leg.veg":"Vegetarian","leg.hot":"Spicy by tradition","leg.hot2":"Very spicy by tradition","best":"Best-seller",
    "menu.foot":"All our dishes are cooked mildly spiced. Spicy or very spicy on request. Wine list available at the restaurant. Allergies or special requests? Just ask our team.",
    "menu.pdf":"Download the menu (PDF)","plats.open":"See our dishes","plats.title":"Our dishes in pictures","plats.all":"Download all","plats.one":"Download","plats.close":"Close","plats.wait":"Preparing…","plats.count":"photos","menu.empty":"No vegetarian dish in this section.",
    "ph.eyebrow":"In pictures","ph.title":"At the Yamouna table","ph.insta":"Our dishes, the dining room and behind the scenes: all our photos are on Instagram.","ph.follow":"Follow on Instagram",
    "rv.eyebrow":"Guest reviews","rv.title":"Our guests say it best",
    "rv.lede":"A few reviews left on Google (in French). Been to see us? Your review helps other food lovers find us.",
    "rv.read":"Read all Google reviews","rv.write":"Write a review","rv.src":"Google review","ph.table":"The Yamouna table",
    "or.eyebrow":"Takeaway · delivery · groups","or.title":"Le Yamouna, at home too",
    "or.take.t":"Takeaway","or.take.d":"Call us to place your order, then pick it up at 16 rue de Robien. Just give us the dish numbers.",
    "or.del.t":"Delivery","or.del.d":"Order and pay online on Uber Eats, delivered to your door in Rennes.","or.del.b":"Order on Uber Eats",
    "gr.t":"Groups & private hire","gr.d":"Birthday, team meal, family gathering: tell us what you are planning and we will get back to you quickly.",
    "gr.name":"Your name","gr.phone":"Phone","gr.date":"Preferred date","gr.count":"Number of guests","gr.type":"Request type",
    "gr.type.group":"Table for a group","gr.type.private":"Private hire of the restaurant","gr.msg":"Message (optional)",
    "gr.send":"Send the request by email","gr.call":"Or call us","gr.hint":"Your request opens in your email app, ready to send.",
    "ct.eyebrow":"Practical info","ct.title":"Visiting Le Yamouna","ct.area":"Saint-Hélier district, a short walk from the city centre.","ct.route":"Directions on Google Maps",
    "ct.hours":"Opening hours","ct.good":"Good to know",
    "f.access":"Wheelchair accessible","f.park":"Easy parking nearby","f.groups":"Groups welcome",
    "f.kids":"Children welcome, kids' menu at €10","f.pets":"Pets allowed","f.diet":"Vegetarian dishes; dietary requests on demand","f.pay":"All payment methods accepted",
    "ft.tag":"Traditional Indian restaurant · Rennes · since 2008","ft.legal":"Legal notice","ft.credit":"Website crafted by","mb.route":"Directions","mb.order":"Order",
    days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
    closedLunch:"closed at lunch", openUntil:h=>`Open · until ${fmtH(h)}`, opensToday:h=>`Closed · opens at ${fmtH(h)}`,
    opensTomorrow:h=>`Closed · opens tomorrow at ${fmtH(h)}`, opensOn:(d,h)=>`Closed · opens ${d} at ${fmtH(h)}`,
    subj:f=>`${f.type==="private"?"Private hire":"Group booking"} request${f.date?" – "+f.date:""}`,
    wa:(f)=>`Hello Le Yamouna, I would like to request ${f.type==="private"?"a private hire":"a group booking"}.\nName: ${f.name||"-"}\nPhone: ${f.phone||"-"}\nDate: ${f.date||"-"}\nGuests: ${f.count||"-"}\n${f.msg?"Message: "+f.msg:""}`,
    tabsLabel:"Menu sections"
  }
};
function fmtH(h){ return h===12 ? "12 pm" : h>12 ? (h-12)+" pm" : h+" am"; }

let lang = "fr";
try { lang = localStorage.getItem("yamouna-lang") || ((navigator.language||"fr").toLowerCase().startsWith("fr") ? "fr" : "en"); } catch(e){ lang = (navigator.language||"fr").toLowerCase().startsWith("fr") ? "fr" : "en"; }
if(!T[lang]) lang = "fr";
let activeTab = MENU[0].id;

const $ = (s,r=document)=>r.querySelector(s);
const $$ = (s,r=document)=>[...r.querySelectorAll(s)];
const money = p => new Intl.NumberFormat(lang==="fr"?"fr-FR":"en-GB",{style:"currency",currency:"EUR",minimumFractionDigits:p%1?2:0,maximumFractionDigits:2}).format(p);
const esc = s => String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));

/* ---------- Liens & coordonnées ---------- */
function applyConfig(){
  const links = {
    tel: (CONFIG.phone ? "tel:+33" + CONFIG.phone.replace(/\s/g,"").slice(1) : ""),
    email: CONFIG.email ? "mailto:" + CONFIG.email : "",
    instagram: CONFIG.instagram, tiktok: CONFIG.tiktok, uber: CONFIG.uber, maps: CONFIG.maps, reviews: CONFIG.reviews
  };
  $$("[data-href]").forEach(a=>{
    const url = links[a.dataset.href];
    if(url){ a.href = url; a.hidden = false; } else { a.hidden = true; }
  });
  $$("[data-cfg]").forEach(el=>{ el.textContent = CONFIG[el.dataset.cfg] || ""; });
  $("#year").textContent = new Date().getFullYear();
}

/* ---------- Heure de Paris & statut ---------- */
function parisNow(){
  const parts = new Intl.DateTimeFormat("en-GB",{timeZone:"Europe/Paris",weekday:"short",hour:"2-digit",minute:"2-digit",hourCycle:"h23"}).formatToParts(new Date());
  const get = t => parts.find(p=>p.type===t).value;
  const day = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].indexOf(get("weekday"));
  return { day, mins: (+get("hour"))*60 + (+get("minute")) };
}
function renderStatus(){
  const L = T[lang], {day, mins} = parisNow();
  let text, open = false;
  const today = HOURS[day] || [];
  const cur = today.find(([a,b])=>mins>=a*60 && mins<b*60);
  if(cur){ open = true; text = L.openUntil(cur[1]); }
  else {
    const later = today.find(([a])=>mins < a*60);
    if(later) text = L.opensToday(later[0]);
    else {
      for(let i=1;i<=7;i++){
        const d=(day+i)%7, s=HOURS[d];
        if(s && s.length){ text = i===1 ? L.opensTomorrow(s[0][0]) : L.opensOn(L.days[d], s[0][0]); break; }
      }
    }
  }
  $("#status").classList.toggle("open", open);
  $("#statusText").textContent = text;

  const order = [2,3,4,5,6,0,1];
  const fmt = ([a,b]) => lang==="fr" ? `${a}h – ${b}h` : `${fmtH(a)} – ${fmtH(b)}`;
  $("#hours").innerHTML = order.map(d=>{
    const s = HOURS[d]||[];
    const lunch = s.find(r=>r[0]<17), dinner = s.find(r=>r[0]>=17);
    const val = `<span>${lunch ? fmt(lunch) : `<span class="closed">${L.closedLunch}</span>`}</span>${dinner ? `<span>${fmt(dinner)}</span>` : ""}`;
    return `<li class="${d===day?"today":""}"><span>${L.days[d]}</span><span class="t">${val}</span></li>`;
  }).join("");
}

/* ---------- La carte ---------- */
function chili(n){ return n ? `<span class="chili" title="${n>1?T[lang]["leg.hot2"]:T[lang]["leg.hot"]}">${'<svg aria-hidden="true"><use href="#i-chili"/></svg>'.repeat(n)}</span><span class="sr-only">${n>1?T[lang]["leg.hot2"]:T[lang]["leg.hot"]}</span>` : ""; }
function renderTabs(){
  const tabs = $("#tabs");
  tabs.setAttribute("aria-label", T[lang].tabsLabel);
  tabs.innerHTML = MENU.map(c=>`<button type="button" role="tab" class="tab" id="tab-${c.id}" data-tab="${c.id}" aria-selected="${c.id===activeTab}" tabindex="${c.id===activeTab?0:-1}">${esc(c[lang])}</button>`).join("");
}
function renderMenu(){
  const vegOnly = $("#vegOnly").checked;
  const cat = MENU.find(c=>c.id===activeTab);
  const board = $("#board");
  board.setAttribute("aria-labelledby","tab-"+cat.id);
  const groups = cat.groups.map(g=>{
    const items = g.items.filter(it=>!vegOnly || it.v);
    const list = items.length ? items.map(it=>{
      const d = it[lang];
      const desc = Array.isArray(d) ? d.map(x=>`<div>${esc(x)}</div>`).join("") : (d ? esc(d) : "");
      const nn = it.no == null;
      return `<li class="item ${Array.isArray(d)?"set":""} ${nn?"nonum":""}">
        ${nn ? "" : `<span class="no">${it.no}</span>`}
        <span class="name">${it.v?`<i class="veg-mark" title="${T[lang]["leg.veg"]}"></i><span class="sr-only">${T[lang]["leg.veg"]}</span>`:""}${esc(it.n)}${chili(it.hot)}${it.star?`<span class="best">${T[lang].best}</span>`:""}</span>
        <span class="price">${money(it.p)}</span>
        ${desc?`<span class="desc">${desc}</span>`:""}
      </li>`;
    }).join("") : `<li class="empty">${T[lang]["menu.empty"]}</li>`;
    const note = g["note_"+lang] ? `<p class="group-note">${esc(g["note_"+lang])}</p>` : "";
    return `<div class="menu-group"><h3>${esc(g[lang])}</h3>${note}<ul class="items">${list}</ul></div>`;
  });
  board.innerHTML = `<div class="menu-groups ${cat.groups.length===1?"single":""}">${groups.join("")}</div>`;
  if(cat.groups.length===1 && cat.groups[0].items.length>6){
    // une seule rubrique longue : on la répartit sur deux colonnes
    const ul = board.querySelector(".items");
    ul.style.cssText = "grid-template-columns:repeat(auto-fit,minmax(min(100%,420px),1fr));column-gap:48px";
  }
}
$("#tabs").addEventListener("click", e=>{
  const b = e.target.closest("[data-tab]"); if(!b) return;
  activeTab = b.dataset.tab; renderTabs(); renderMenu(); $("#tab-"+activeTab).focus();
});
$("#tabs").addEventListener("keydown", e=>{
  if(!["ArrowLeft","ArrowRight"].includes(e.key)) return;
  const i = MENU.findIndex(c=>c.id===activeTab);
  const n = (i + (e.key==="ArrowRight"?1:-1) + MENU.length) % MENU.length;
  activeTab = MENU[n].id; renderTabs(); renderMenu(); $("#tab-"+activeTab).focus(); e.preventDefault();
});
$("#vegOnly").addEventListener("change", renderMenu);

/* ---------- Prix des spécialités ---------- */
function renderPrices(){ $$("[data-price]").forEach(el=>el.textContent = money(+el.dataset.price)); }

/* ---------- Formulaire groupes -> WhatsApp ---------- */
function updateWa(){
  const f = {name:$("#gName").value.trim(), phone:$("#gPhone").value.trim(), date:$("#gDate").value, count:$("#gCount").value, type:$("#gType").value, msg:$("#gMsg").value.trim()};
  if(f.date){ const [y,m,d] = f.date.split("-"); f.date = lang==="fr" ? `${d}/${m}/${y}` : `${d}/${m}/${y}`; }
  $("#mailSend").href = `mailto:${CONFIG.email}?subject=${encodeURIComponent(T[lang].subj(f))}&body=${encodeURIComponent(T[lang].wa(f).trim())}`;
}
$("#groupForm").addEventListener("input", updateWa);
$("#groupForm").addEventListener("submit", e=>e.preventDefault());

/* ---------- Traduction ---------- */
function applyLang(){
  document.documentElement.lang = lang;
  $$("[data-i18n]").forEach(el=>{ const v = T[lang][el.dataset.i18n]; if(typeof v==="string") el.textContent = v; });
  $$(".lang button").forEach(b=>b.setAttribute("aria-pressed", b.dataset.lang===lang));
  renderTabs(); renderMenu(); renderStatus(); renderPrices(); updateWa(); updatePdfButton(); if(window.YamounaPlats) window.YamounaPlats.lang(lang);
}
$$(".lang button").forEach(b=>b.addEventListener("click",()=>{
  lang = b.dataset.lang;
  try{ localStorage.setItem("yamouna-lang", lang); }catch(e){}
  applyLang();
}));

/* ---------- Carte PDF (vrai fichier, FR ou EN selon la langue) ---------- */
function updatePdfButton(){
  const btn = $("#pdfBtn"); if(!btn) return;
  const custom = (CONFIG.menuPdf || "").trim();
  btn.href = custom || btn.dataset["pdf"+(lang==="en"?"En":"Fr")] || btn.dataset.pdfFr;
  btn.target = "_blank"; btn.rel = "noopener";
  btn.setAttribute("download", lang==="en" ? "Le-Yamouna-Menu.pdf" : "Carte-Le-Yamouna.pdf");
}

/* ---------- Étoiles des avis ---------- */
function drawStars(){
  $$(".rstars").forEach(el=>{
    const n = +el.dataset.stars;
    el.innerHTML = [1,2,3,4,5].map(i=>`<svg class="${i>n?"off":""}" aria-hidden="true"><use href="#i-star"/></svg>`).join("") + `<span class="sr-only">${n}/5</span>`;
  });
}

/* ---------- Mandala (rangoli) du bandeau ---------- */
function drawMandala(){
  const g = $("#mandala");
  const layers = [
    {n:8,  r:38,  rx:14, ry:30, c:"#B8442C"},
    {n:12, r:78,  rx:15, ry:34, c:"#E0913A"},
    {n:16, r:118, rx:12, ry:30, c:"#F2DDB8"},
    {n:24, r:156, rx:9,  ry:24, c:"#E0913A"},
    {n:32, r:190, rx:6,  ry:14, c:"#B8442C"}
  ];
  let s = `<circle r="205" fill="none" stroke="#E0913A" stroke-opacity=".35" stroke-width="1.5"/><circle r="172" fill="none" stroke="#F6D7A1" stroke-opacity=".25" stroke-dasharray="2 8" stroke-width="2"/>`;
  layers.forEach((L,li)=>{
    for(let i=0;i<L.n;i++){
      const a = i/L.n*360 + (li%2 ? 180/L.n : 0);
      s += `<ellipse cx="0" cy="${-L.r}" rx="${L.rx}" ry="${L.ry}" fill="${L.c}" opacity="${li===2?.85:1}" transform="rotate(${a})"/>`;
      if(li===1||li===3) s += `<circle cx="0" cy="${-(L.r+L.ry+8)}" r="3" fill="#FDF3E1" transform="rotate(${a})"/>`;
    }
  });
  s += `<circle r="24" fill="#E0913A"/><circle r="14" fill="#0C0D10"/><circle r="6" fill="#FDF3E1"/>`;
  g.innerHTML = s;
}

/* ---------- Démarrage ---------- */
applyConfig();
drawMandala();
drawStars();
applyLang();
setInterval(renderStatus, 60000);
